module.exports = __webpack_public_path__ + "static/media/dunce.fb8be6f8.png";